module.exports = __webpack_public_path__ + "img/多翼创新.02a66e97.png";